( () => {

	/**
	 * Block name
	 *
	 * @type {string}
	 */
	const blockName = 'accordion';

	/**
	 * Init
	 */
	window.addEventListener( 'load', () => {

		const blocks = document.querySelectorAll( `.block-${ blockName }` );
		if ( blocks.length > 0 ) {

			blocks.forEach( ( block ) => {

				initializeBlock( block );

			} );

		}

	} );

	/**
	 * Toggle single accordion component
	 *
	 * @param {object} block
	 */
	const toggleAccordion = ( block ) => {

		const accordions = block.querySelectorAll( '.c-accordion' );

		if ( accordions.length > 0 ) {

			accordions.forEach( ( accordion ) => {

				const accordionContent = accordion.querySelector( '.c-accordion__content' );

				if ( accordionContent ) {

					accordion.querySelector( '.js-accordion-toggle-button' ).addEventListener( 'click', () => {

						accordion.classList.toggle( 'c-accordion--opened' );

						if ( accordion.classList.contains( 'c-accordion--opened' ) ) {

							accordionContent.style.maxHeight = `${ accordionContent.scrollHeight }px`;

						} else {

							accordionContent.style.maxHeight = '';

						}

					} );

				}

			} );

		}

	}

	/**
	 * Block init
	 *
	 * @param {object} block
	 */
	const initializeBlock = ( block ) => {

		if ( block[ 0 ] !== undefined ) {

			block = block[ 0 ].querySelector( `.block-${ blockName }` );

		}
		if ( block === false || block === null ) {}

		// Block Code Here
		toggleAccordion( block );

	};

} )();
